export default __webpack_public_path__ + "static/media/classify-kristine.22fd2ba8.jpg";